import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import "./premiumprojects.scss";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Allprojectstables from "./DataTable/Allprojectstables";
import Draftprojectstables from "./DataTable/Draftprojectstables";
import { Link } from "react-router-dom";
import Createpremiumprojects from "./Createpremiumprojects/Createpremiumprojects";
import Loader from "../../../hooks/loader";

const Allpremiumprojects = ({ setRoutes, routes }) => {
  const [key, setKey] = useState("allprojects");
  const [status, setStatuses] = useState(null);
  const [search, setSearch] = useState("");
  const [boolSearch, setBoolSearch] = useState(false);
  const [loader, setLoader] = useState(false);
  const [id, setId] = useState(null);

  // validate route
  useEffect(() => {
    console.log("called 2");
    let _id = localStorage?.getItem("draftProjectId");
    if (_id) {
      setLoader(true);
      setId(_id);
      // setTimeout(() => {
      // console.log("reoun", routes);
      setRoutes(true);
      setLoader(false);
      // }, [3000]);
    }
  }, [routes]);

  return (
    <>
      {loader && <Loader />}
      {routes || id ? (
        <Createpremiumprojects setRoutes={setRoutes} setId={setId} />
      ) : (
        <section className="allpremiumprojects">
          <div className="custom-container">
            <div className="topmain">
              <div className="topleft">
                <p className="leftpara">Premium Projects</p>
                <h1 className="allhead">All Projects</h1>
              </div>
              <div className="desktop_toop">
                <div className="topright">
                  {key !== "draftprojects" && (
                    <Dropdown className="statusdropdown">
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        {status === null ? (
                          "All Statuses"
                        ) : (
                          <>
                            {status === "SALE_UPCOMING" ? (
                              "Upcoming"
                            ) : (
                              <>{status === "SALE_LIVE" ? "Live" : "Ended"} </>
                            )}{" "}
                          </>
                        )}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="6"
                          viewBox="0 0 13 6"
                          fill="none"
                        >
                          <path
                            d="M0 0L2.22397e-07 2.5462L6.2 6L6.2 3.4538L0 0Z"
                            fill="#02171D"
                          />
                          <path
                            d="M12.3984 0L12.3984 2.5462L6.19844 6L6.19844 3.4538L12.3984 0Z"
                            fill="#02171D"
                          />
                        </svg>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <div className="allstatus">
                          <h4 onClick={() => setStatuses(null)}>All</h4>
                          <h4 onClick={() => setStatuses("SALE_UPCOMING")}>
                            Upcoming
                          </h4>
                          <h4 onClick={() => setStatuses("SALE_LIVE")}>Live</h4>
                          <h4 onClick={() => setStatuses("SALE_ENDED")}>
                            Ended
                          </h4>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                  <div className="top_innner">
                    <div className="maininput">
                      <input
                        placeholder="Search by name, creator email or wallet address"
                        type="text"
                        className="innerinput"
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <svg
                        onClick={() => setBoolSearch(!boolSearch)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        className="searchsvg"
                      >
                        <path
                          d="M10.0006 8.73281C9.37544 9.70902 8.28128 10.356 7.036 10.356C5.09309 10.356 3.51806 8.78102 3.51806 6.83812C3.51806 4.89522 5.09309 3.32018 7.036 3.32018C8.9789 3.32018 10.5539 4.89522 10.5539 6.83812C10.5539 7.39671 10.4237 7.9249 10.192 8.39399L12.5735 8.39399C12.7123 7.89913 12.7865 7.37729 12.7865 6.83812C12.7865 3.66222 10.2119 1.08765 7.036 1.08765C3.8601 1.08765 1.28552 3.66222 1.28552 6.83812C1.28552 10.014 3.8601 12.5886 7.036 12.5886C8.66122 12.5886 10.129 11.9144 11.1748 10.8304L10.0006 8.73281Z"
                          fill="#0A2931"
                        />
                        <path
                          d="M14.9075 16.835L15.6358 14.1168L10.0372 8.66481L9.30888 11.383L14.9075 16.835Z"
                          fill="#0A2931"
                        />
                      </svg>
                    </div>
                    <button
                      onClick={() => {
                        setRoutes(true);
                      }}
                      className="createbtn"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M2.66667 14.6667H12C12.3536 14.6667 12.6928 14.5262 12.9428 14.2761C13.1929 14.0261 13.3333 13.687 13.3333 13.3333V4.66667L10 1.33334H4.00001C3.64638 1.33334 3.30724 1.47381 3.0572 1.72386C2.80715 1.97391 2.66667 2.31305 2.66667 2.66667V5.33334"
                          stroke="#E2E9EC"
                          stroke-linecap="square"
                        />
                        <path
                          d="M9.33333 1.33334V4C9.33333 4.35362 9.4738 4.69276 9.72385 4.94281C9.9739 5.19286 10.313 5.33334 10.6667 5.33334H13.3333"
                          stroke="#E2E9EC"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2 10H6"
                          stroke="#E2E9EC"
                          stroke-linecap="square"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M4 8V12"
                          stroke="#E2E9EC"
                          stroke-linecap="square"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Create Project
                    </button>
                  </div>
                </div>
              </div>

              <div className="phone_top">
                <div className="topright">
                  <div className="maininput">
                    <input
                      placeholder="Search by name, creator email or wallet address"
                      type="text"
                      className="innerinput"
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <svg
                      onClick={() => setBoolSearch(!boolSearch)}
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      className="searchsvg"
                    >
                      <path
                        d="M10.0006 8.73281C9.37544 9.70902 8.28128 10.356 7.036 10.356C5.09309 10.356 3.51806 8.78102 3.51806 6.83812C3.51806 4.89522 5.09309 3.32018 7.036 3.32018C8.9789 3.32018 10.5539 4.89522 10.5539 6.83812C10.5539 7.39671 10.4237 7.9249 10.192 8.39399L12.5735 8.39399C12.7123 7.89913 12.7865 7.37729 12.7865 6.83812C12.7865 3.66222 10.2119 1.08765 7.036 1.08765C3.8601 1.08765 1.28552 3.66222 1.28552 6.83812C1.28552 10.014 3.8601 12.5886 7.036 12.5886C8.66122 12.5886 10.129 11.9144 11.1748 10.8304L10.0006 8.73281Z"
                        fill="#0A2931"
                      />
                      <path
                        d="M14.9075 16.835L15.6358 14.1168L10.0372 8.66481L9.30888 11.383L14.9075 16.835Z"
                        fill="#0A2931"
                      />
                    </svg>
                  </div>
                  {key !== "draftprojects" && (
                    <div className="top_innner">
                      <Dropdown className="statusdropdown">
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          {status === null ? (
                            "All Statuses"
                          ) : (
                            <>
                              {status === "SALE_UPCOMING" ? (
                                "Upcoming"
                              ) : (
                                <>
                                  {status === "SALE_LIVE" ? "Live" : "Ended"}{" "}
                                </>
                              )}{" "}
                            </>
                          )}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="6"
                            viewBox="0 0 13 6"
                            fill="none"
                          >
                            <path
                              d="M0 0L2.22397e-07 2.5462L6.2 6L6.2 3.4538L0 0Z"
                              fill="#02171D"
                            />
                            <path
                              d="M12.3984 0L12.3984 2.5462L6.19844 6L6.19844 3.4538L12.3984 0Z"
                              fill="#02171D"
                            />
                          </svg>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <div className="allstatus">
                            <h4 onClick={() => setStatuses(null)}>All</h4>
                            <h4 onClick={() => setStatuses("SALE_UPCOMING")}>
                              Upcoming
                            </h4>
                            <h4 onClick={() => setStatuses("SALE_LIVE")}>
                              Live
                            </h4>
                            <h4 onClick={() => setStatuses("SALE_ENDED")}>
                              Ended
                            </h4>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                      <button
                        onClick={() => {
                          setRoutes(true);
                        }}
                        className="createbtn"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M2.66667 14.6667H12C12.3536 14.6667 12.6928 14.5262 12.9428 14.2761C13.1929 14.0261 13.3333 13.687 13.3333 13.3333V4.66667L10 1.33334H4.00001C3.64638 1.33334 3.30724 1.47381 3.0572 1.72386C2.80715 1.97391 2.66667 2.31305 2.66667 2.66667V5.33334"
                            stroke="#E2E9EC"
                            stroke-linecap="square"
                          />
                          <path
                            d="M9.33333 1.33334V4C9.33333 4.35362 9.4738 4.69276 9.72385 4.94281C9.9739 5.19286 10.313 5.33334 10.6667 5.33334H13.3333"
                            stroke="#E2E9EC"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M2 10H6"
                            stroke="#E2E9EC"
                            stroke-linecap="square"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4 8V12"
                            stroke="#E2E9EC"
                            stroke-linecap="square"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Create Project
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => {
                setKey(k);
              }}
              className="projectstabs"
            >
              <Tab eventKey="allprojects" title="All Projects">
                <Allprojectstables
                  search={search}
                  status={status}
                  boolSearch={boolSearch}
                  setRoutes={setRoutes}
                  tabKey={key}
                  routes={routes}
                />
              </Tab>
              <Tab eventKey="draftprojects" title="Draft Projects">
                <Draftprojectstables
                  search={search}
                  boolSearch={boolSearch}
                  setRoutes={setRoutes}
                  tabKey={key}
                  routes={routes}
                />
              </Tab>
            </Tabs>
          </div>
        </section>
      )}
    </>
  );
};

export default Allpremiumprojects;
